module.exports = __webpack_public_path__ + "img/diary_prew_1.e9e578cb.png";